import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SignupPaymentAction from '../actions/SignupPaymentAction';
import CheckoutButton from '../../components/checkout/CheckoutButton/CheckoutButton';

const mapStateToProps = state => ({
  formValues: state.form.checkout.values
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    storePaymentDetails: SignupPaymentAction.storePaymentDetails
  }, dispatch);

const CheckoutButtonContainer = connect(mapStateToProps, mapDispatchToProps)(CheckoutButton);

export default CheckoutButtonContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/CheckoutButtonContainer.js
 **/